<script>
    import Select from "svelte-select/Select.svelte";

    import {
        searchMbsItems,
        updateConsultItems,
        updateModifierItems,
        updateNonCategoryItems,
        updateProcedureItems,
        updateSurgeryItems,
        updateTimeItems,
    } from "../../../helpers/mbsHelper.svelte";

    import { mbsAllItemsList } from "../../../../../stores";

    export let itemProps = {},
        selectedItems = [],
        holidaysInState = [],
        infoTypesMap = new Map(),
        updateItems = () => {},
        openNotification = () => {};

    $: if ($mbsAllItemsList.length && infoTypesMap.size) _syncSpecialItems();

    let searchItemResult = {};

    let specialItemsForSurgery = [];

    let defaultProcedureItems = [];

    const loadMBSItems = async (searchText) => {
        if (!searchText) return [];

        let res = await searchMbsItems(searchText);

        if (!res || !res.length) return [];

        const result = [];

        res.filter(
            (item) => !selectedItems.some((sItem) => sItem.id == item.id),
        ).map((item) =>
            result.push({
                ...item,
                displayName: getMbsOptionLabel(item),
            }),
        );

        return result;
    };

    const getMbsOptionLabel = (option) =>
        `${option.itemNum} ${
            option.subItemNum ? `(${option.subItemNum})` : ""
        } - ${
            option.infoShortTitle ? option.infoShortTitle : option.description
        }`;

    const handleChangeItem = (item, actionType = "add") => {
        switch (item.infoType) {
            case "Consults":
            case "Cardiac":
                updateItems(
                    updateConsultItems(
                        item,
                        selectedItems,
                        actionType,
                        itemProps.billingType == 3,
                    ),
                );
                break;
            case "Surgery":
                updateItems(
                    updateSurgeryItems(
                        item,
                        selectedItems,
                        itemProps,
                        specialItemsForSurgery,
                    ),
                );
                break;
            case "Modifiers":
                updateItems(updateModifierItems(item, selectedItems));
                break;
            case "AdditionalProcedures":
                const resArr = updateProcedureItems(
                    item,
                    selectedItems,
                    itemProps,
                    defaultProcedureItems,
                    holidaysInState,
                    true,
                    openNotification,
                );

                updateItems(resArr);

                const { billingType } = itemProps;

                // sync neuraxialType from deleting procedure item
                if (billingType == 2 && actionType == "delete") {
                    const insertionItems = [18216, 18219, 18226, 18227];
                    const topUpItems = [18222, 18225];

                    const hasInsertionItemsLeft = resArr.some((item) =>
                        insertionItems.includes(item.itemNum),
                    );
                    const hasTopUpItemsLeft = resArr.some((item) =>
                        topUpItems.includes(item.itemNum),
                    );

                    itemProps.neuraxialType =
                        hasInsertionItemsLeft && hasTopUpItemsLeft
                            ? 3
                            : hasTopUpItemsLeft
                              ? 2
                              : hasInsertionItemsLeft
                                ? 1
                                : 0;
                }
                break;
            case "Time":
                updateItems(updateTimeItems(item, selectedItems));
                break;
            default:
                updateItems(updateNonCategoryItems(item, selectedItems));
                break;
        }

        clearSelectItem();
    };

    const clearSelectItem = () => (searchItemResult.item = null);

    // HELPER FUNCTIONS
    const _syncSpecialItems = () => {
        const specialModifierItemCodes = [25013, 25014];

        $mbsAllItemsList.map((item) => {
            if (
                (item.infoType == "Modifiers" &&
                    specialModifierItemCodes.includes(item.itemNum)) ||
                item.infoType == "Time"
            )
                specialItemsForSurgery.push(item);
        });

        defaultProcedureItems = infoTypesMap.get("AdditionalProcedures");
    };
</script>

<div class="flex flex-col gap-y-4 p-4">
    <div class="flex flex-1">
        <Select
            bind:value={searchItemResult.item}
            class="flex flex-1 max-h-[35px] rounded-full"
            loadOptions={loadMBSItems}
            itemId="id"
            label="displayName"
            on:select={() => handleChangeItem(searchItemResult.item)}
            on:clear={clearSelectItem}
            noOptionsMessage="No MBS item found"
            placeholder="Search MBS item"
        />
    </div>

    {#if selectedItems.length}
        <div class="flex flex-1 flex-wrap items-center gap-x-2">
            <p>Selected MBS items:</p>
            {#each selectedItems as item}
                <!-- svelte-ignore a11y-click-events-have-key-events -->
                <div
                    class="flex cursor-default bg-secondary min-w-[36px] rounded-lg text-[#fff] relative"
                >
                    <p class="px-2 py-1 z-[0]">{item.itemNum}</p>
                    <!-- svelte-ignore a11y-click-events-have-key-events -->
                    <!-- svelte-ignore a11y-no-static-element-interactions -->
                    <div
                        class="absolute text-[#fff] cursor-pointer w-[20px] top-[-5px] right-[-5px] bg-red-600/50 hover:bg-red-600 rounded rounded-lg px-1 z-[1] text-xs text-center"
                        on:click|preventDefault={() =>
                            handleChangeItem(item, "delete")}
                    >
                        X
                    </div>
                </div>
            {/each}
        </div>
    {/if}
</div>
